import React from "react";
import { ReactElement } from "react";

import Carousel from "../Carousel";
import { listUrl } from "../Data";
import LogosWrapper from "../LogosWrapper";

const LogosCarousel = (): ReactElement => {
  const settings = {
    infinite: true,
    speed: 8000,
    slidesToShow: 7,
    slidesToScroll: 3,
    autoplaySpeed: 0,
    autoplay: true,
    initialSlide: 0,
    cssEase: "linear",
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "0px",
          slidesToShow: 1,
          rows: 1,
          slidesPerRow: 1,
        },
      },
    ],
  };

  const products = listUrl.logosCarousel.item;

  return (
    <Carousel settings={settings}>
      {products &&
        products.map((product) => (
          <LogosWrapper
            imgLink={product.img}
            imgAlt={product.alt}
            productLink={""}
            key={product.alt}
          />
        ))}
    </Carousel>
  );
};

export default LogosCarousel;
